module.exports = __webpack_public_path__ + "static/ps-2-9b47e331361d038e7ed6f002ae968577.jpg";